<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-06-19',
        major: [
          '第2弾',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : '第2弾',
            id          : 'PCH2-01',
            rare        : 'KR',
            name        : 'ガールズエールキラッとワンピ',
            imgUrl      : '/images/items/PCH2-01.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 1900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-02',
            rare        : 'KR',
            name        : 'ガールズエールキラッとシューズ',
            imgUrl      : '/images/items/PCH2-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-03',
            rare        : 'KR',
            name        : 'ガールズエールキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH2-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'KR',
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-04',
            rare        : 'KR',
            name        : 'ドーリーワルツキラッとワンピ',
            imgUrl      : '/images/items/PCH2-04.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-05',
            rare        : 'KR',
            name        : 'ドーリーワルツキラッとシューズ',
            imgUrl      : '/images/items/PCH2-05.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-06',
            rare        : 'KR',
            name        : 'ドーリーワルツキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH2-06.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : '第2弾',
            id          : 'PCH2-07',
            rare        : 'PR',
            name        : 'ノーブルドールトップス',
            imgUrl      : '/images/items/PCH2-07.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-08',
            rare        : 'PR',
            name        : 'ノーブルドールボトムス',
            imgUrl      : '/images/items/PCH2-08.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-09',
            rare        : 'PR',
            name        : 'ノーブルドールシューズ',
            imgUrl      : '/images/items/PCH2-09.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-10',
            rare        : 'PR',
            name        : 'ノーブルドールヘアアクセ',
            imgUrl      : '/images/items/PCH2-10.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            rare        : 'PR',
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-11',
            rare        : 'PR',
            name        : 'ノーブルドールハーフパンツ',
            imgUrl      : '/images/items/PCH2-11.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'PR',
          }),
          item({
            collection  : '第2弾',
            rare        : 'PR',
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-12',
            rare        : 'PR',
            name        : 'パンクキャットレッドトップス',
            imgUrl      : '/images/items/PCH2-12.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-13',
            rare        : 'PR',
            name        : 'パンクキャットレッドスカート',
            imgUrl      : '/images/items/PCH2-13.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-14',
            rare        : 'PR',
            name        : 'パンクキャットレッドシューズ',
            imgUrl      : '/images/items/PCH2-14.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-15',
            rare        : 'PR',
            name        : 'パンクキャットレッドヘアアクセ',
            imgUrl      : '/images/items/PCH2-15.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-16',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエロートップス',
            imgUrl      : '/images/items/PCH2-16.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-17',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエロースカート',
            imgUrl      : '/images/items/PCH2-17.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-18',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエローシューズ',
            imgUrl      : '/images/items/PCH2-18.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-19',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエローヘアアクセ',
            imgUrl      : '/images/items/PCH2-19.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : '第2弾',
            id          : 'PCH2-20',
            rare        : 'SR',
            name        : 'セーラーマリンライトブルートップス',
            imgUrl      : '/images/items/PCH2-20.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-21',
            rare        : 'SR',
            name        : 'セーラーマリンライトブルースカート',
            imgUrl      : '/images/items/PCH2-21.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-22',
            rare        : 'SR',
            name        : 'セーラーマリンライトブルーシューズ',
            imgUrl      : '/images/items/PCH2-22.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-23',
            rare        : 'SR',
            name        : 'セーラーマリンライトブルーヘアアクセ',
            imgUrl      : '/images/items/PCH2-23.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-24',
            rare        : 'SR',
            name        : 'スターダストレザーブルートップス',
            imgUrl      : '/images/items/PCH2-24.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-25',
            rare        : 'SR',
            name        : 'スターダストレザーブルースカート',
            imgUrl      : '/images/items/PCH2-25.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-26',
            rare        : 'SR',
            name        : 'スターダストレザーブルーブーツ',
            imgUrl      : '/images/items/PCH2-26.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-27',
            rare        : 'SR',
            name        : 'スターダストレザーブルーヘアアクセ',
            imgUrl      : '/images/items/PCH2-27.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-28',
            rare        : 'SR',
            name        : 'ピクニックギンガムレッドケープワンピ',
            imgUrl      : '/images/items/PCH2-28.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-29',
            rare        : 'SR',
            name        : 'ピクニックギンガムレッドシューズ',
            imgUrl      : '/images/items/PCH2-29.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-30',
            rare        : 'SR',
            name        : 'ピクニックギンガムレッドヘアアクセ',
            imgUrl      : '/images/items/PCH2-30.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'SR',
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-31',
            rare        : 'SR',
            name        : 'ミュージシャンホワイトジャケット',
            imgUrl      : '/images/items/PCH2-31.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-32',
            rare        : 'SR',
            name        : 'ミュージシャンホワイトデニム',
            imgUrl      : '/images/items/PCH2-32.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-33',
            rare        : 'SR',
            name        : 'ミュージシャンホワイトシューズ',
            imgUrl      : '/images/items/PCH2-33.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-34',
            rare        : 'SR',
            name        : 'ミュージシャンホワイトハット',
            imgUrl      : '/images/items/PCH2-34.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '第2弾',
            id          : 'PCH2-35',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームレッドトップス',
            imgUrl      : '/images/items/PCH2-35.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-36',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームレッドスカート',
            imgUrl      : '/images/items/PCH2-36.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-37',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームレッドシューズ',
            imgUrl      : '/images/items/PCH2-37.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-38',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームレッドヘアアクセ',
            imgUrl      : '/images/items/PCH2-38.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-39',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームグリーントップス',
            imgUrl      : '/images/items/PCH2-39.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'PS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-40',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームグリーンスカート',
            imgUrl      : '/images/items/PCH2-40.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 11 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-41',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームグリーンシューズ',
            imgUrl      : '/images/items/PCH2-41.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-42',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームグリーンヘアアクセ',
            imgUrl      : '/images/items/PCH2-42.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-43',
            rare        : 'R',
            name        : 'ストライプローズワンピ',
            imgUrl      : '/images/items/PCH2-43.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-44',
            rare        : 'R',
            name        : 'リボンソックス&ストライプシューズ',
            imgUrl      : '/images/items/PCH2-44.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'R',
          }),
          item({
            collection  : '第2弾',
            rare        : 'R',
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-45',
            rare        : 'R',
            name        : 'ロッカーレッドベスト＆Tシャツ',
            imgUrl      : '/images/items/PCH2-45.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-46',
            rare        : 'R',
            name        : 'ロッカーダメージホワイトショーパン',
            imgUrl      : '/images/items/PCH2-46.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-47',
            rare        : 'R',
            name        : 'ロッカーブラックローファー',
            imgUrl      : '/images/items/PCH2-47.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '第2弾',
            id          : 'PCH2-48',
            rare        : 'N',
            name        : 'ミリタリーホワイトニット＆ショーパン',
            imgUrl      : '/images/items/PCH2-48.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-49',
            rare        : 'N',
            name        : 'ミリタリーグリーンブーツ',
            imgUrl      : '/images/items/PCH2-49.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'N',
          }),
          item({
            collection  : '第2弾',
            rare        : 'N',
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-50',
            rare        : 'N',
            name        : 'パンジーガールミントブラウス',
            imgUrl      : '/images/items/PCH2-50.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-51',
            rare        : 'N',
            name        : 'パンジーガールミントスカート',
            imgUrl      : '/images/items/PCH2-51.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-52',
            rare        : 'N',
            name        : 'パンジーガールミントシューズ',
            imgUrl      : '/images/items/PCH2-52.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'N',
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-53',
            rare        : 'N',
            name        : 'グリーンチェックレディートップス',
            imgUrl      : '/images/items/PCH2-53.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-54',
            rare        : 'N',
            name        : 'グリーンチェックレディースカート',
            imgUrl      : '/images/items/PCH2-54.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-55',
            rare        : 'N',
            name        : 'グリーンチェックレディーシューズ',
            imgUrl      : '/images/items/PCH2-55.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-56',
            rare        : 'N',
            name        : 'グリーンチェックレディーヘアアクセ',
            imgUrl      : '/images/items/PCH2-56.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-57',
            rare        : 'N',
            name        : 'ツートンカラーパターントップス',
            imgUrl      : '/images/items/PCH2-57.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-58',
            rare        : 'N',
            name        : 'ツートンカラーパターンボトムス',
            imgUrl      : '/images/items/PCH2-58.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-59',
            rare        : 'N',
            name        : 'ツートンカラーパターンシューズ',
            imgUrl      : '/images/items/PCH2-59.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-60',
            rare        : 'N',
            name        : 'ツートンカラーパターンヘアアクセ',
            imgUrl      : '/images/items/PCH2-60.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-61',
            rare        : 'N',
            name        : 'ホワイトローズトップス',
            imgUrl      : '/images/items/PCH2-61.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-62',
            rare        : 'N',
            name        : 'ホワイトローズボトムス',
            imgUrl      : '/images/items/PCH2-62.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-63',
            rare        : 'N',
            name        : 'ホワイトローズシューズ',
            imgUrl      : '/images/items/PCH2-63.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-64',
            rare        : 'N',
            name        : 'ホワイトローズヘアアクセ',
            imgUrl      : '/images/items/PCH2-64.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-65',
            rare        : 'N',
            name        : 'みらいせいふくワンピ',
            imgUrl      : '/images/items/PCH2-65.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-66',
            rare        : 'N',
            name        : 'みらいせいふくローファー',
            imgUrl      : '/images/items/PCH2-66.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 300,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-67',
            rare        : 'N',
            name        : 'みらいせいふくリボンヘアアクセ',
            imgUrl      : '/images/items/PCH2-67.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 300,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '第2弾',
            id          : 'PCH2-68',
            rare        : 'SR',
            name        : 'レッドローズ',
            imgUrl      : '/images/items/PCH2-68.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-69',
            rare        : 'SR',
            name        : 'ももいろウサギさんぬいぐるみ',
            imgUrl      : '/images/items/PCH2-69.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '第2弾',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '第2弾',
            id          : 'PCH2-70',
            rare        : 'R',
            name        : 'クリームソーダ',
            imgUrl      : '/images/items/PCH2-70.png',
            kind        : 'パシャッとアイテム',
            color       : '緑',
            brand       : 'DW',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-71',
            rare        : 'R',
            name        : 'ハッピーステッキ',
            imgUrl      : '/images/items/PCH2-71.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            id          : 'PCH2-72',
            rare        : 'R',
            name        : 'デリシャスオムライス',
            imgUrl      : '/images/items/PCH2-72.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : '',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第2弾',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] なかよしチャンネル
          // ================================================================================

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH2-77',
            rare        : 'R',
            name        : 'ラッキーステッキ',
            imgUrl      : '/images/items/PCH2-77.png',
            kind        : 'パシャッとアイテム',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH2-78',
            rare        : 'R',
            name        : 'オレンジソーダ',
            imgUrl      : '/images/items/PCH2-78.png',
            kind        : 'パシャッとアイテム',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH2-79',
            rare        : 'SR',
            name        : 'そらいろウサギさんぬいぐるみ',
            imgUrl      : '/images/items/PCH2-79.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH2-80',
            rare        : 'SR',
            name        : 'パープルローズ',
            imgUrl      : '/images/items/PCH2-80.png',
            kind        : 'パシャッとアイテム',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          // [NOTE] 期間限定チャンネル
          // ================================================================================

          item({
            collection  : 'キラ宿選抜スペシャル大会',
            id          : 'SP-001',
            rare        : 'ＳＲ',
            name        : 'プリ☆チャンユニフォームピュアホワイトトップス',
            imgUrl      : '/images/items/SP-001.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラ宿選抜スペシャル大会',
            id          : 'SP-002',
            rare        : 'ＳＲ',
            name        : 'プリ☆チャンユニフォームピュアホワイトスカート',
            imgUrl      : '/images/items/SP-002.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラ宿選抜スペシャル大会',
            id          : 'SP-003',
            rare        : 'ＳＲ',
            name        : 'プリ☆チャンユニフォームピュアホワイトシューズ',
            imgUrl      : '/images/items/SP-003.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'キラ宿選抜スペシャル大会',
            id          : 'SP-004',
            rare        : 'ＳＲ',
            name        : 'プリ☆チャンユニフォームピュアホワイトヘアアクセ',
            imgUrl      : '/images/items/SP-004.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PS',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'セーラーチアレッドリボンライブ',
            id          : 'PCH2-73',
            rare        : 'SR',
            name        : 'セーラーチアレッドリボントップス',
            imgUrl      : '/images/items/PCH2-73.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'セーラーチアレッドリボンライブ',
            id          : 'PCH2-74',
            rare        : 'SR',
            name        : 'セーラーチアレッドリボンスカート',
            imgUrl      : '/images/items/PCH2-74.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'セーラーチアレッドリボンライブ',
            id          : 'PCH2-75',
            rare        : 'SR',
            name        : 'セーラーチアレッドリボンシューズ',
            imgUrl      : '/images/items/PCH2-75.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'セーラーチアレッドリボンライブ',
            id          : 'PCH2-76',
            rare        : 'SR',
            name        : 'セーラーチアレッドリボンヘアアクセ',
            imgUrl      : '/images/items/PCH2-76.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-01',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらトップス',
            imgUrl      : '/images/items/PAF2-01.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-02',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらスカート',
            imgUrl      : '/images/items/PAF2-02.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-03',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらシューズ',
            imgUrl      : '/images/items/PAF2-03.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-04',
            rare        : 'R',
            name        : 'プリティーオールフレンズあいらヘアアクセ',
            imgUrl      : '/images/items/PAF2-04.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-05',
            rare        : 'R',
            name        : 'プリティーオールフレンズりずむトップス',
            imgUrl      : '/images/items/PAF2-05.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PS',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-06',
            rare        : 'R',
            name        : 'プリティーオールフレンズりずむパンツ',
            imgUrl      : '/images/items/PAF2-06.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PS',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-07',
            rare        : 'R',
            name        : 'プリティーオールフレンズりずむシューズ',
            imgUrl      : '/images/items/PAF2-07.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-08',
            rare        : 'R',
            name        : 'プリティーオールフレンズりずむヘアアクセ',
            imgUrl      : '/images/items/PAF2-08.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PS',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-09',
            rare        : 'R',
            name        : 'プリティーオールフレンズみおんトップス',
            imgUrl      : '/images/items/PAF2-09.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-10',
            rare        : 'R',
            name        : 'プリティーオールフレンズみおんスカート',
            imgUrl      : '/images/items/PAF2-10.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-11',
            rare        : 'R',
            name        : 'プリティーオールフレンズみおんシューズ',
            imgUrl      : '/images/items/PAF2-11.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF2-12',
            rare        : 'R',
            name        : 'プリティーオールフレンズみおんヘアアクセ',
            imgUrl      : '/images/items/PAF2-12.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ブランドチャンネル
          // ================================================================================

          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-01',
            rare        : 'SR',
            name        : 'セーラーマリンパステルピンクトップス',
            imgUrl      : '/images/items/DW-01.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-02',
            rare        : 'SR',
            name        : 'セーラーマリンパステルピンクスカート',
            imgUrl      : '/images/items/DW-02.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-03',
            rare        : 'SR',
            name        : 'セーラーマリンパステルピンクシューズ',
            imgUrl      : '/images/items/DW-03.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-04',
            rare        : 'SR',
            name        : 'セーラーマリンパステルピンクヘアアクセ',
            imgUrl      : '/images/items/DW-04.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-05',
            rare        : 'SR',
            name        : 'ピクニックギンガムブルーケープワンピ',
            imgUrl      : '/images/items/DW-05.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-06',
            rare        : 'SR',
            name        : 'ピクニックギンガムブルーシューズ',
            imgUrl      : '/images/items/DW-06.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            id          : 'DW-07',
            rare        : 'SR',
            name        : 'ピクニックギンガムブルーヘアアクセ',
            imgUrl      : '/images/items/DW-07.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dolly Waltz チャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-01',
            rare        : 'SR',
            name        : 'スターダストレザーピンクトップス',
            imgUrl      : '/images/items/RB-01.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-02',
            rare        : 'SR',
            name        : 'スターダストレザーピンクスカート',
            imgUrl      : '/images/items/RB-02.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-03',
            rare        : 'SR',
            name        : 'スターダストレザーピンクブーツ',
            imgUrl      : '/images/items/RB-03.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-04',
            rare        : 'SR',
            name        : 'スターダストレザーピンクヘアアクセ',
            imgUrl      : '/images/items/RB-04.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-05',
            rare        : 'SR',
            name        : 'ミュージシャンイエロージャケット',
            imgUrl      : '/images/items/RB-05.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-06',
            rare        : 'SR',
            name        : 'ミュージシャンイエローデニム',
            imgUrl      : '/images/items/RB-06.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-07',
            rare        : 'SR',
            name        : 'ミュージシャンイエローシューズ',
            imgUrl      : '/images/items/RB-07.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Romance Beat チャンネル',
            id          : 'RB-08',
            rare        : 'SR',
            name        : 'ミュージシャンイエローハット',
            imgUrl      : '/images/items/RB-08.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsKR () {
        return _.where(this.itemsMaJor, {  rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, {  rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsNakayoshiChannel () {
        return _.where(this.itemsFiltered, { collection: 'なかよしチャンネル' })
      },

      itemsKirajukuSP () {
        return _.where(this.itemsFiltered, { collection: 'キラ宿選抜スペシャル大会' })
      },

      itemsSCRRLive () {
        return _.where(this.itemsFiltered, { collection: 'セーラーチアレッドリボンライブ' })
      },

      itemsPAFChannel () {
        return _.where(this.itemsFiltered, { collection: 'プリティーオールフレンズチャンネル' })
      },

      itemsDWChannel () {
        return _.where(this.itemsFiltered, { collection: 'Dolly Waltz チャンネル' })
      },

      itemsRBChannel () {
        return _.where(this.itemsFiltered, { collection: 'Romance Beat チャンネル' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col3>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>

    <template #col4>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="なかよしチャンネル" color="#c598ff" :items="itemsNakayoshiChannel" />
      <ItemList title="Dolly Waltz チャンネル" color="#c598ff" :items="itemsDWChannel" />
      <ItemList title="Romance Beat チャンネル" color="#c598ff" :items="itemsRBChannel" />
    </template>

    <template #col5>
      <ItemList title="プリズムストーン presents|キラ宿選抜スペシャル大会" color="#a1c0fa" :items="itemsKirajukuSP" />
      <ItemList title="セーラーチアレッドリボンライブ" color="#a1c0fa" :items="itemsSCRRLive" />
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#a1c0fa" :items="itemsPAFChannel" />
      <Status :date="date" :items="items" :showKira="true" :showKR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    left: 0;
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
    .Page ::v-deep .Page__body {
      padding-bottom: $size-unit * 40;
    }
  }
</style>
